import { render, staticRenderFns } from "./getewayRealInfo_3D.vue?vue&type=template&id=77bef24e&"
import script from "./getewayRealInfo_3D.vue?vue&type=script&lang=js&"
export * from "./getewayRealInfo_3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports